import React from "react";
import { Link } from "react-router-dom";
import styles from "./Home.module.css";
import EventThumbnail from "../../shared/PageThumbnails/event_thumbnail.png";
import ZoneMap from "../../shared/PageThumbnails/zone_map.png";
import MutualAid from "../../shared/PageThumbnails/mutual_aid.png"

function Home() {
  return (
    <div className={styles.container}>

      <Link to="/events" className={styles.card}>
        <img src={EventThumbnail} alt="Events" />
        <h3>Events</h3>
        <p>See upcoming events and actions.</p>
      </Link>

      <Link to="/ogMap" className={styles.card}>
        <img src={ZoneMap} alt="Map" />
        <h3>Ogden Map</h3>
        <p>Explore locations around Ogden.</p>
      </Link>

      <Link to="https://www.ogdenmutualaid.com/" className={styles.card}>
        <img src={MutualAid} alt="Map" />
        <h3>Mutual Aid</h3>
        <p>Engage with your community. Be a resource. Find Help.</p>
      </Link>

    </div>
  );
}

export default Home;